<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<h1 class="center">The Ballad and the Source</h1>
<h2 class="center" style="margin-top:20px;">A Novel</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Lehmann_BalladSource_3P_MD.vue?20d5948c